import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Tooltip } from "@mui/material";
import { useState } from "react";
import formatDateToDDMMYYYY from "../../utils/formatDate";

export default function ProfileAccessKeys({ keys, games, compact = false }) {
  const [copied, setCopied] = useState(null);

  if (!keys?.length) {
    return null;
  }

  const handleCopy = async (value, key) => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(key);
      setTimeout(() => setCopied(null), 2000);
    } catch {
      setCopied(null);
    }
  };

  return (
    <section
      className={`app-profile-card app-profile-card--compact${
        compact ? " app-profile-card--optional" : ""
      }`}
    >
      <h3 className="app-profile-card__title">Ключи доступа</h3>

      <div className="app-table-wrap app-profile-keys">
        <table className="app-table app-table--compact app-table--keys">
          <thead>
            <tr>
              <th>Проект</th>
              <th>Ключ</th>
              <th>Статус</th>
            </tr>
          </thead>
          <tbody>
            {keys.map((item) => {
              const project = games?.find((game) => game._id === item.game);

              return (
                <tr key={item.key}>
                  <td>{project?.title ?? "—"}</td>
                  <td>
                    <div className="app-table__key-cell">
                      <span>{item.key}</span>
                      <Tooltip
                        title={
                          copied === item.key ? "Скопировано" : "Копировать"
                        }
                        placement="top"
                      >
                        <ContentCopyIcon
                          sx={{ cursor: "pointer", fontSize: 16 }}
                          onClick={() => handleCopy(item.key, item.key)}
                        />
                      </Tooltip>
                    </div>
                  </td>
                  <td>
                    {item.availeble
                      ? "Свободен"
                      : item.usageDate
                        ? formatDateToDDMMYYYY(item.usageDate)
                        : "Использован"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
}
